var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForwardArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 15,
    viewBox: "0 0 33 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.8259 8.20711C32.2165 7.81658 32.2165 7.18342 31.8259 6.79289L25.462 0.428932C25.0715 0.0384079 24.4383 0.0384079 24.0478 0.428932C23.6572 0.819456 23.6572 1.45262 24.0478 1.84315L29.7046 7.5L24.0478 13.1569C23.6572 13.5474 23.6572 14.1805 24.0478 14.5711C24.4383 14.9616 25.0715 14.9616 25.462 14.5711L31.8259 8.20711ZM-0.00805664 8.5H31.1188V6.5H-0.00805664L-0.00805664 8.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardArrow);
export default __webpack_public_path__ + "static/media/forward-arrow.f2467f8775fe6fcaf62665ec41354095.svg";
export { ForwardRef as ReactComponent };